import { isPlatformBrowser } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MenuItem } from 'primeng/api';
import { City } from 'src/app/modules/entities/city';
import { Setting } from 'src/app/modules/entities/setting';
import { CityService } from 'src/app/modules/services/city.service';
import { LoginService } from 'src/app/modules/services/login.service';
import { SettingService } from 'src/app/modules/services/setting.service';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  constructor(private router: Router, private cookies: CookieService, private cityService: CityService, private loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object, private settingsService: SettingService) {
    if (isPlatformBrowser(this.platformId)) {
      this.isTerms = location.pathname === '/' + url['terminos'];
    }
  }

  url = url;
  isTerms: boolean = false;
  showDialog: boolean = false;
  cities: City[] = [];
  selectedCity: City | undefined;
  isUserLogged: boolean = false;
  loggedUser: string = '';
  menuItems: MenuItem[] = [];
  visibleMenu: boolean = false;
  registrationNumber: string | number = 0;


  ngOnInit() {
    this.getVisibleCities();
    this.validateDialog();
    this.validateAutentication();
    this.validateIdentity();
    this.getSettings();

  }

  validateDialog() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cookies.check('termsAccepted') || this.isTerms) {
        this.showDialog = false;
      } else {
        this.showDialog = true;
      }
    }
  }

  validateAutentication() {
    this.loginService.auth.subscribe({
      next: (token: string) => {
        this.isUserLogged = token.length > 10;
      }
    });
  }

  getSettings() {
    this.settingsService.getRegistrationNumber().subscribe({
      next: response => {
        if (response.status === 'success') {
          this.registrationNumber = (response.data as Setting).value;
          if (isPlatformBrowser(this.platformId)) {
            this.cookies.set('contact', JSON.stringify(this.registrationNumber));
          }
        }
      }
    })
  }

  validateIdentity() {
    this.loginService.loggedUser.subscribe({
      next: (loggedUser: string) => {
        this.loggedUser = loggedUser;
        this.menuItems = this.getMenu();
      }
    });
  }

  getVisibleCities() {
    this.cityService.getCities().subscribe(response => {
      if (response.status === 'success') {
        this.cities = response.data.filter(city => city.visible === 1);
        this.cookies.set('cities', JSON.stringify(response.data));
        this.validateIdentity();
      }
    });

  }

  getIn() {
    this.cookies.delete('termsAccepted');
    this.cookies.set('termsAccepted', 'true');
    this.showDialog = false;
  }

  displayDialog() {
    this.showDialog = true;
  }

  getCityUrl(citySearchName: string): string {
    return '/' + url['lista-perfiles'] + '/' + citySearchName;
  }

  getUrl(pageId: string): string {
    return '/' + url[pageId];
  }

  getMenu(): MenuItem[] {
    let citiesMenu: MenuItem[] = [];
    for (let city of this.cities.filter(city => city.visible === 1)) {
      citiesMenu.push({
        label: city.name,
        title: 'Escorts ' + city.name,
        routerLink: this.getPersonListUrl(city.searchName, ''),
        command: () => {
          this.visibleMenu = false;
        }
      });
    }
    let menu: MenuItem[] = [{
      label: 'Ciudades',
      items: citiesMenu
    },
    {
      label: 'Categorías',
      items: [{
        label: 'Baratas',
        title: 'Escorts Baratas',
        routerLink: this.getPersonListUrl('baratas', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'A domicilio',
        title: 'Escorts A domicilio',
        routerLink: this.getPersonListUrl('a-domicilio', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'Maduras',
        title: 'Escorts Maduras',
        routerLink: this.getPersonListUrl('maduras', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'Universitarias',
        title: 'Escorts Universitarias',
        routerLink: this.getPersonListUrl('universitarias', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: '18 años',
        title: 'Escorts de 18 años',
        routerLink: this.getPersonListUrl('18-anos', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'Tetonas',
        title: 'Escorts Tetonas',
        routerLink: this.getPersonListUrl('tetonas', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'Gorditas',
        title: 'Escorts Gorditas',
        routerLink: this.getPersonListUrl('gorditas', ''),
        command: () => {
          this.visibleMenu = false;
        }
      },
      {
        label: 'Morenas',
        title: 'Escorts Morenas',
        routerLink: this.getPersonListUrl('morenas', ''),
        command: () => {
          this.visibleMenu = false;
        }
      }]
    }];
    if (this.isUserLogged) {
      if (this.loggedUser === 'admin') {
        menu.unshift({
          label: 'Administración',
          items: [{
            label: 'Panel de administración',
            icon: 'pi pi-user',
            command: () => {
              this.goToAdministration()
            }
          },
          {
            label: 'Estadísticas de interacciones',
            icon: 'pi pi-chart-bar',
            command: () => {
              this.goToInteractionStatistics()
            }
          },
          {
            label: 'Cerrar sesión',
            icon: 'pi pi-times',
            command: () => {
              this.logout();
            }
          }]
        });
      } else {
        menu.unshift({
          label: 'Perfil',
          items: [{
            label: 'Ver',
            icon: 'pi pi-user',
            command: () => {
              this.goToProfile()
            }
          },
          {
            label: 'Detalles',
            icon: 'pi pi-chart-line',
            command: () => {
              this.goToProfileDetails()
            }
          },
          {
            label: 'Editar',
            icon: 'pi pi-pencil',
            command: () => {
              this.goToEditProfile()
            }
          },
          {
            label: 'Imágenes',
            icon: 'pi pi-images',
            command: () => {
              this.goToEditMedia()
            }
          },
          {
            label: 'Servicio al cliente',
            icon: 'pi pi-question-circle',
            command: () => {
              this.contactUs();
            }
          },
          {
            label: 'Cerrar sesión',
            icon: 'pi pi-times',
            command: () => {
              this.logout();
            }
          }
          ]
        });
      }
    } else {
      menu.unshift({
        items: [{
          label: 'Inicio',
          icon: 'pi pi-home',
          command: () => {
            this.goHome()
          }
        },
        {
          label: 'Iniciar sesión',
          icon: 'pi pi-user',
          command: () => {
            this.goToLogin()
          }
        },
        {
          label: 'Registrarse',
          icon: 'pi pi-user-plus',
          command: () => {
            this.goToRegister()
          }
        }
        ]
      });
    }
    return menu;
  }

  goHome() {
    this.router.navigate([url['home']]);
    this.visibleMenu = false;
  }

  goToProfile() {
    if (isPlatformBrowser(this.platformId)) {
      const loggedUser = sessionStorage.getItem('loggedUser');
      this.router.navigate([url['perfil'], loggedUser]);
      this.visibleMenu = false;
    }
  }

  goToEditProfile() {
    if (isPlatformBrowser(this.platformId)) {
      const loggedUser = sessionStorage.getItem('loggedUser');
      this.router.navigate([url['editar-perfil'], loggedUser]);
      this.visibleMenu = false;
    }
  }

  goToEditMedia() {
    if (isPlatformBrowser(this.platformId)) {
      const loggedUser = sessionStorage.getItem('loggedUser');
      this.router.navigate([url['editar-media'], loggedUser]);
      this.visibleMenu = false;
    }
  }

  goToProfileDetails() {
    if (isPlatformBrowser(this.platformId)) {
      const loggedUser = sessionStorage.getItem('loggedUser');
      this.router.navigate([url['detalle-perfil'], loggedUser]);
      this.visibleMenu = false;
    }
  }

  goToLogin() {
    this.router.navigate([url['login']]);
    this.visibleMenu = false;
  }

  goToAdministration() {
    this.router.navigate([url['administracion']]);
    this.visibleMenu = false;
  }

  goToInteractionStatistics() {
    this.router.navigate([url['interacciones']]);
    this.visibleMenu = false;
  }

  goToTerms() {
    this.router.navigate([url['terminos']]);
    this.visibleMenu = false;
  }

  getPersonListUrl(city: string, locality: string) {
    let finalUrl: string;
    if (locality) {
      finalUrl = url['lista-perfiles'] + '/' + city + '/' + locality;
    } else {
      finalUrl = url['lista-perfiles'] + '/' + city;
    }
    return finalUrl;
  }

  goToRegister() {
    this.router.navigate([url['registro-1']]);
    this.visibleMenu = false;
  }

  logout() {
    this.isUserLogged = false;
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem('loggedUser');
      sessionStorage.removeItem('auth');
    }
    this.goHome();
    this.isUserLogged = false;
    this.loggedUser = '';
    this.menuItems = this.getMenu();
    this.visibleMenu = false;
  }

  contactUs() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.registrationNumber;
    window.open(contactUrl);
  }

  ngOnDestroy(): void {
    this.loginService.authBS.unsubscribe();
    this.loginService.loggedUserBS.unsubscribe();
  }
}
